<div fxLayout="column" fxLayoutGap="40px" class="panel">
    <div>{{ 'Choose the month for which to delete data:'|i18n }}</div>
    <div [formGroup]="form" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="50px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div fxFlex="80">{{ 'Select year'|i18n }}:</div>
            <mat-select app-small-select placeholder="{{'Year'|i18n}}"
                        [disabled]="!Object.keys(yearAndMonths).length"
                        (selectionChange)="onYearChange()"
                        formControlName="year">
                <mat-option *ngFor="let year of Object.keys(yearAndMonths)"
                            [value]="year"
                            class="txt-p-16-4">
                    {{ year }}
                </mat-option>
            </mat-select>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div fxFlex="80">{{ 'Select month'|i18n }}:</div>
            <mat-select app-small-select placeholder="{{'Month'|i18n}}"
                        [disabled]="!year"
                        formControlName="month">
                <mat-option *ngFor="let month of yearAndMonths[year]"
                            [value]="month.month"
                            class="txt-p-16-4">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div [ngClass]="month.consolidated ? 'legend-dot accent' : 'legend-dot accent-variant'"
                             [matTooltip]="(month.consolidated ? 'Consolidated' : 'Non consolidated')|i18n"></div>
                        <div>{{ MONTHS[month.month]|i18n }}</div>
                    </div>
                </mat-option>
            </mat-select>
        </div>
    </div>
</div>
